import { expVal } from '@atlassian/jira-feature-experiments';

export const isBulkOpsInNinEnabled = {
	get(): boolean {
		return expVal('bulk_operations_in_nin_experiment', 'isEnabled', false);
	},
};

export default isBulkOpsInNinEnabled;
